import React, { useState, useRef, useEffect } from 'react';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import logo from "../assets/Logo/Austin logo light.png";

function Navbar() {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        const name = currentUser.displayName || currentUser.email;
        const firstName = name?.split(' ')[0] || "Friend";
        setUser({
          firstName,
          photoURL: currentUser.photoURL || null
        });
      } else {
        setUser(null);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      setUser(null);
      navigate('/');
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <section className="absolute top-0 left-0 w-full z-50">
      <nav className="font-inter w-full bg-transparent">
        <div className="w-full max-w-7xl mx-auto px-6 py-10 md:px-10 xl:px-20">
          <div className="relative flex items-center">
            {/* Logo */}
            <a
              href="/"
              className="absolute left-1/2 transform -translate-x-1/2 md:static md:translate-x-0 md:left-auto"
              aria-label="Home"
            >
              <img src={logo} alt="Austin Plant Rescue Logo" className="h-28 w-auto" />
            </a>

            {/* Desktop Nav Links */}
            <div className="hidden md:flex items-center space-x-10 text-lg font-medium text-white ml-auto">
              <a href="#about" className="hover:text-[#C17C45]">About Us</a>
              <a href="#services" className="hover:text-[#C17C45]">Services</a>
              <a href="/whyus" className="hover:text-[#C17C45]">Why Us</a>
              <a href="/client" className="hover:text-[#C17C45]">Client Love</a>
            </div>

            {/* Desktop CTA Button (hidden on mobile) */}
            <a
              href="https://book.squareup.com/appointments/xxgm3rjcbdu4ud/location/LC274M19X7T68/services/474A67W5TVCL3BDLQQHOVL6I"
              className="hidden md:block"
            >
              <button className="bg-[#1A3C34] text-white px-4 py-2 ml-10 rounded-full text-[16px] font-semibold hover:bg-[#2e5d50] transition-colors duration-300">
                Book Plant Sitting
              </button>
            </a>

            {/* Mobile menu button */}
            <button
              className="md:hidden ml-auto text-[#1A3C34] font-bold text-3xl"
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {menuOpen ? "✕" : "☰"}
            </button>
          </div>

          {/* Mobile Menu */}
          {menuOpen && (
            <div className="md:hidden mt-4 flex flex-col items-center space-y-4 bg-white shadow-lg rounded-lg py-6">
              <a
                href="/about"
                className="text-[#3C2415] font-medium hover:text-green-700"
                onClick={() => setMenuOpen(false)}
              >
                About Me
              </a>
              <a
                href="/services"
                className="text-[#3C2415] font-medium hover:text-green-700"
                onClick={() => setMenuOpen(false)}
              >
                Services
              </a>
              <a
                href="/blog"
                className="text-[#3C2415] font-medium hover:text-green-700"
                onClick={() => setMenuOpen(false)}
              >
                Blog
              </a>
              <a
                href="/contactus"
                className="text-[#3C2415] font-medium hover:text-green-700"
                onClick={() => setMenuOpen(false)}
              >
                Inquire
              </a>

              {/* Book Plant Sitting (mobile version) */}
              <a
                href="https://book.squareup.com/appointments/xxgm3rjcbdu4ud/location/LC274M19X7T68/services/474A67W5TVCL3BDLQQHOVL6I"
                onClick={() => setMenuOpen(false)}
              >
                <button className="bg-[#1A3C34] text-white px-5 py-2 rounded-full font-semibold hover:bg-[#2e5d50] transition-colors duration-300">
                  Book Plant Sitting
                </button>
              </a>
            </div>
          )}
        </div>
      </nav>
    </section>
  );
}

export default Navbar;
